import * as React from "react";
import {
  TableCell,
  Button,
  Link,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
} from "@fluentui/react-components";
import { Call24Regular, ChevronDown16Regular } from "@fluentui/react-icons";
import { useTelephony } from "../context/TelephonyContext";

type Phone = {
  id: string;
  label?: string; // z.B. "Mobil", "Büro", "Privat"
  number: string; // z.B. "+49 171 1234567"
  primary?: boolean;
};

function PhoneCell({
  item,
  phones,
  onSetPrimary, // (phoneId: string) => void
}: {
  item: any;
  phones: Phone[];
  onSetPrimary?: (id: string) => void;
}) {
  // Click-to-call geht app-weit über den zentralen Helper ans SDK-Widget (ADR 0002).
  const { callNumber } = useTelephony();
  const primary = React.useMemo(
    () => phones.find((p) => p.primary) ?? phones[0],
    [phones],
  );

  const other = phones.filter((p) => p.id !== primary?.id);

  return (
    <TableCell
      // wichtig: Spaltengröße etc. wenn du columnSizing_unstable nutzt
      onClick={(e) => {
        /* Row-Click/Edit zulassen */
      }}
    >
      <div
        style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}
      >
        {/* Hauptnummer als Klick-zum-Anrufen (kein tel:-Link mehr → SDK-Widget) */}
        <Link
          as="button"
          disabled={!primary}
          onClick={(e) => {
            e.stopPropagation();
            if (primary) callNumber(primary.number);
          }}
          title={primary?.number}
          style={{
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          {primary?.number ?? "—"}
        </Link>

        {/* Call-Button */}
        <Button
          icon={<Call24Regular />}
          appearance="subtle"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (primary) callNumber(primary.number);
          }}
          aria-label="Anrufen"
          title={`Anrufen: ${primary?.number ?? ""}`}
        />

        {/* Dropdown für weitere Nummern */}
        {other.length > 0 && (
          <Menu>
            <MenuTrigger disableButtonEnhancement>
              <Button
                icon={<ChevronDown16Regular />}
                appearance="subtle"
                size="small"
                onClick={(e) => e.stopPropagation()}
                aria-label="Weitere Telefonnummern"
                title="Weitere Telefonnummern"
              />
            </MenuTrigger>
            <MenuPopover onClick={(e) => e.stopPropagation()}>
              <MenuList>
                {other.map((p) => (
                  <MenuItem
                    key={p.id}
                    onClick={() => onSetPrimary?.(p.id)}
                    // aria-label enthält beide Infos für SR
                    aria-label={`${p.label ?? "Weitere"}: ${p.number}`}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: 1.15,
                      }}
                    >
                      <span style={{ fontSize: 12, opacity: 0.8 }}>
                        {p.label ?? "Weitere"}
                      </span>
                      <span style={{ fontWeight: 500 }}>{p.number}</span>
                    </div>
                  </MenuItem>
                ))}
              </MenuList>
            </MenuPopover>
          </Menu>
        )}
      </div>
    </TableCell>
  );
}

export default PhoneCell;
